(function (){
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .factory('TransactionReports', Transactions);

  function Transactions(Api, MAX_CONVERSION, ConsumerChart, StandardReports, CalloutLabelService){

    return {
      updateConversions: updateConversions,
      transactionSummaryChartDetails: transactionSummaryChartDetails,
      shopperSummaryChartDetails: shopperSummaryChartDetails,
      sessionOrderChartDetails: sessionOrderChartDetails,
      revenueChartDetails: revenueChartDetails,
      aovUPTChartDetails: aovUPTChartDetails,
      incrementalRevenueChartDetails: incrementalRevenueChartDetails
    };

    function updateConversions(conversion) {
      conversion.conversions.forEach(function(x){
        _.forEach(x.metricValues, function(d){
          if(d.value > MAX_CONVERSION) {
            d.value = MAX_CONVERSION;
          }
        })
      });
    }

    function sum(arr) { return _.sumBy(arr, 'value') }

    function shopperSummaryChartDetails(data, filterConfig, summaryRoundScale) {
      var chartDetails = summaryChartDetails({userCohort: 'TrueFit'}, {userCohort: 'NonTrueFit'})
      (data.dateMetrics, filterConfig);

      var summaryDetails = {
        tf: _.round(data.mean.tfValue, summaryRoundScale),
        nonTF: _.round(data.mean.nonTFValue, summaryRoundScale),
        sitewide: _.round(data.mean.allValue, summaryRoundScale)
      };

      return _.extend(chartDetails, summaryDetails);
    }

    function transactionSummaryChartDetails(data, filterConfig, sectionCallout) {
      var chartDetails = summaryChartDetails({isTFUser: true}, {isTFUser: false})
      (data, filterConfig);

      var summaryDetails = {
        tf: sum(_.find(chartDetails.lineData, {lineType: 'tfLine'}).data),
        nonTF: sum(_.find(chartDetails.lineData, {lineType: 'nonTFLine'}).data)
      };

      var sitewide = summaryDetails.tf + summaryDetails.nonTF;

      var summaryPercentDetails = _.reduce(summaryDetails, function (acc, value, userType) {
        acc[CalloutLabelService[userType](sectionCallout).percentOutOfAttributeName] = StandardReports.percentTotal(value, sitewide);
        return acc;
      }, {});

      return _.extend(chartDetails, summaryDetails, summaryPercentDetails);
    }

    function summaryChartDetails(tfFilter, nonTfFilter) {
      return function(data, filterConfig) {
        var tfFilteredData = ConsumerChart.getChartData(data, _.extend(filterConfig, tfFilter));
        var nonTFFilteredData = ConsumerChart.getChartData(data, _.extend(filterConfig, nonTfFilter));

        return {
          lineData: [
            {lineType: 'tfLine', data: tfFilteredData, label: 'TF'},
            {lineType: 'nonTFLine', data: nonTFFilteredData, label: 'Non-TF'}
          ]
        }
      }
    }

    function sessionOrderChartDetails(data, filterConfig, summaryDataFn, summaryLineFilter, label) {
      var filteredData =  ConsumerChart.getChartData(data, filterConfig);
      var summaryData = _.filter(summaryDataFn(data).lineData, summaryLineFilter);

      var filtered = sum(filteredData);
      var usedForReporting = sum(_.flatMap(summaryData, 'data'));
      var filteredPct = StandardReports.filteredPercent(filtered + usedForReporting, usedForReporting);
      var totalLineData = [
        {lineType: 'totalLine', data: filteredData, label: label, stackedTotal: true}
      ];

      return {
        total: filtered + usedForReporting,
        usedForReporting: usedForReporting,
        filteredPct: filteredPct,
        lineData: _.concat(summaryData, totalLineData)
      }
    }

    function revenueChartConfig(sitewideFilter, sitewideLabel) {
      var filters = [
        { filter: {userCohort: 'TrueFit', isBot: false}, lineType: 'tfLine', label: 'TF', labelValueType: "tf" },
        { filter: {userCohort: 'NonTrueFit', isBot: false}, lineType: 'nonTFLine', label: 'Non-TF', labelValueType: "nonTF" },
      ];

      if(sitewideFilter) {
        filters.push({ filter: sitewideFilter, lineType: 'totalLine', label: sitewideLabel,
          labelValueType: "sitewideWithBots", stackedTotal: true });
      }
      return filters;
    }

    function incrementalRevenueChartDetails(data) {
      var formattedData = _.map(data.dateMetrics, function (dateMetrics) {
        return {
          date: dateMetrics.startDate,
          value: _.round(dateMetrics.value)
        }
      });
      var lineData = [
        {lineType: 'tfLine', data: formattedData, label: 'TF'}
      ];

      return {
        lineData: lineData,
        tf: _.round(data['totalIncrementalRevenue'])
      }
    }

    function revenueChartDetails(data, calloutSection) {
      var config = revenueChartConfig({userCohort: 'All', isBot: true}, 'Sitewide + Bots');

      var lineData = _.map(config, function (line) {
        var filteredData = ConsumerChart.getChartData(data, line.filter);
        return {lineType: line.lineType, data: filteredData, label: line.label, stackedTotal: line.stackedTotal}
      });

      var summaryData = _.reduce(config, function (acc,line) {
        var data = _.find(lineData, {lineType: line.lineType}).data;
        var labelValue = CalloutLabelService[line.labelValueType](calloutSection);
        acc[labelValue.attributeName] = sum(data);
        return acc;
      }, {});

      //override sitewide as its total value is different then plotted values
      summaryData.sitewideWithBots = sum(ConsumerChart.getChartData(data, function (metric) {
        return _.eq(metric.userCohort, 'All') && _.isUndefined(metric.isBot);
      }));

      var sitewideWithoutBot = summaryData.tf + summaryData.nonTF;

      var summaryPercent = _.reduce(config, function (acc,line) {
        var labelValue = CalloutLabelService[line.labelValueType](calloutSection);
        if(labelValue.percentOutOfAttributeName)
          acc[labelValue.percentOutOfAttributeName] = StandardReports.percentTotal(summaryData[labelValue.attributeName], sitewideWithoutBot);
        return acc;
      }, {});

      return _.merge({lineData: lineData}, summaryData, summaryPercent);
    }

    function aovUPTChartDetails(data, metric) {
      var config = revenueChartConfig();

      var lineData = _.map(config, function (line) {
        var filteredData = ConsumerChart.getChartData(data.dateMetrics, line.filter);
        return {lineType: line.lineType, data: filteredData, label: line.label}
      });

      var metricSummary = data[metric];

      var summaryData = {
        change: metricSummary.lift,
        tf: metricSummary.mean.tfValue,
        nonTF: metricSummary.mean.nonTFValue,
        siteWide: metricSummary.mean.sitewideValue
      };

      return _.merge({lineData: lineData}, summaryData);

    }

  }
})();